import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=6e9f467a&"
import script from "./notifications.vue?vue&type=script&lang=js&"
export * from "./notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports